const slinkEndpointPrefix = '/admin/slink'

const slinkEndpoints = {
    exclusion: (id: number) => slinkEndpointPrefix + `/v4/management/users/${id}/exclusion`,
    syncMatchSetting: (id: number) => slinkEndpointPrefix + `/v1/management/sync-match-setting/${id}`
}

export default slinkEndpoints